<template>
<div class="container">
    <div class="common-header-wrap">
        <mt-header title="视频" class="common-header">
            <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
    </div>
    <div class="common-popup-content">
        <video v-if="detailInfo.goodsvideo_url" style="width:100%;height:100%" autoplay="autoplay" controls="controls" controlslist="nodownload" :src="detailInfo.goodsvideo_url" />
    </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'HomeGoodsVideo',
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo
    })
  },
  created () {

  },
  methods: {

  }

}
</script>

<style scoped lang="scss">
    
</style>
